var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.data.href,"target":_vm.target}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }